import ChatWidget from '../components/chat/ChatWidget';
import './Home.css';

export default function Home() {
  return (
    <div className="home-page">
      <div className="home-content">
        <div className="home-badge">AI-Powered Support</div>
        <h1 className="home-title">
          Welcome to Our<br />
          <span className="home-title-accent">Support Center</span>
        </h1>
        <p className="home-desc">
          Have questions? Our AI assistant is available 24/7 to help you with
          product info, pricing, and more. Click the chat button below.
        </p>
        <div className="home-hint">
          <span>💬</span>
          <span>Click the <strong>Chat</strong> button in the bottom-right corner to start</span>
        </div>
      </div>
      <ChatWidget />
    </div>
  );
}
